import useSWR from 'swr';
import { trpc } from '../../../api/trpc';

export const useBrandsList = () => {
  const { data, isLoading, error } = useSWR(['brandAdmin.list'], () =>
    trpc.brandAdmin.list.query(),
  );

  return { data, isLoading, error };
};

export const useBrands = () => {
  const { data, isLoading, error } = useSWR(['brandAdmin.brands'], () =>
    trpc.brandAdmin.brands.query(),
  );

  return { data, isLoading, error };
};
